import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import {
  params,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { RedirectTag, useHelmet } from '@thd-nucleus/thd-helmet';
import { RedirectContext } from './RedirectContext';
import { isNotFound } from './rules/vendor-collections-redirect-rules';
import { handleErrors, ERROR_HANDLING_EXPERIENCE } from '../utils/redirector-utils';

const vendorCollectionHandler = ({ data, error, props }) => {

  const {
    collectionName,
    bypass
  } = props;

  const errors = handleErrors(error, ERROR_HANDLING_EXPERIENCE.GENERIC);
  if (errors) {
    return new RedirectTag(errors, bypass);
  }

  const noMeta = isNotFound({ data, collectionName });
  if (noMeta) {
    return new RedirectTag(noMeta, bypass);
  }

  return null;
};

export const VendorCollectionsRedirector = ({ collectionName }) => {
  
  const { bypass } = useContext(RedirectContext);
  const props = {
    collectionName,
    bypass
  };

  const opts = {
    variables: {
      collectionName
    },
    ssr: true
  };

  const { data, error } = useDataModel('fetchCollectionsContent', opts);
  useHelmet('VendorCollectionsRedirector', { data, error, props }, vendorCollectionHandler, [collectionName]);

  return null;
};

VendorCollectionsRedirector.displayName = 'VendorCollectionsRedirector';

VendorCollectionsRedirector.propTypes = {
  collectionName: string.isRequired
};

VendorCollectionsRedirector.defaultProps = {};

VendorCollectionsRedirector.dataModel = {
  fetchCollectionsContent: params({ collectionName: stringType().isRequired() }).shape({
    title: stringType()
  })
};
